namespace TabAurous.OMS {
    export interface SubCategoryDetailsRow {
        DetailId?: number;
        SubCategoryId?: number;
        CategoryId?: number;
        SubCategoryName?: string;
        SubCategoryCode?: string;
    }

    export namespace SubCategoryDetailsRow {
        export const idProperty = 'DetailId';
        export const localTextPrefix = 'OMS.SubCategoryDetails';
        export const lookupKey = 'OMS.SubType';

        export function getLookup(): Q.Lookup<SubCategoryDetailsRow> {
            return Q.getLookup<SubCategoryDetailsRow>('OMS.SubType');
        }
        export const deletePermission = 'Product:SubCategory:Delete';
        export const insertPermission = 'Product:SubCategory:Add';
        export const readPermission = '*';
        export const updatePermission = 'Product:SubCategory:Edit';

        export declare const enum Fields {
            DetailId = "DetailId",
            SubCategoryId = "SubCategoryId",
            CategoryId = "CategoryId",
            SubCategoryName = "SubCategoryName",
            SubCategoryCode = "SubCategoryCode"
        }
    }
}
